import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_storage_7387f8c1 from 'nuxt_plugin_storage_7387f8c1' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_gtm_fa7b7308 from 'nuxt_plugin_gtm_fa7b7308' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_libmoduleplugin7915e51a_03e8c30a from 'nuxt_plugin_libmoduleplugin7915e51a_03e8c30a' // Source: ./lib.module.plugin.7915e51a.js (mode: 'client')
import nuxt_plugin_templatesplugin22357a2f_25ce8c54 from 'nuxt_plugin_templatesplugin22357a2f_25ce8c54' // Source: ./templates.plugin.22357a2f.js (mode: 'all')
import nuxt_plugin_axios_3c602e26 from 'nuxt_plugin_axios_3c602e26' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_5e512832 from 'nuxt_plugin_moment_5e512832' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vuefroala_7b108d3d from 'nuxt_plugin_vuefroala_7b108d3d' // Source: ../../../plugins/lib/vue-froala.js (mode: 'client')
import nuxt_plugin_videoPlayer_07925bfb from 'nuxt_plugin_videoPlayer_07925bfb' // Source: ../../../plugins/lib/videoPlayer.js (mode: 'client')
import nuxt_plugin_animatedscrollto_34d657c6 from 'nuxt_plugin_animatedscrollto_34d657c6' // Source: ../../../plugins/lib/animated-scroll-to.js (mode: 'client')
import nuxt_plugin_vue2animate_b95efc92 from 'nuxt_plugin_vue2animate_b95efc92' // Source: ../../../plugins/lib/vue2-animate.js (mode: 'client')
import nuxt_plugin_vueawesomeswiper_548c0e4e from 'nuxt_plugin_vueawesomeswiper_548c0e4e' // Source: ../../../plugins/lib/vue-awesome-swiper.js (mode: 'client')
import nuxt_plugin_vuebar_2f78316c from 'nuxt_plugin_vuebar_2f78316c' // Source: ../../../plugins/lib/vuebar.js (mode: 'client')
import nuxt_plugin_fullcalendar_50d0b408 from 'nuxt_plugin_fullcalendar_50d0b408' // Source: ../../../plugins/lib/full-calendar (mode: 'client')
import nuxt_plugin_utils_0acf3c7e from 'nuxt_plugin_utils_0acf3c7e' // Source: ../../../plugins/core/utils/utils.js (mode: 'client')
import nuxt_plugin_validate_20fc9549 from 'nuxt_plugin_validate_20fc9549' // Source: ../../../plugins/core/utils/validate.js (mode: 'client')
import nuxt_plugin_disableLogs_3cc606b9 from 'nuxt_plugin_disableLogs_3cc606b9' // Source: ../../../plugins/core/setting/disableLogs.js (mode: 'all')
import nuxt_plugin_portalCommon_2614ff1a from 'nuxt_plugin_portalCommon_2614ff1a' // Source: ../../../plugins/portal/portalCommon.js (mode: 'client')
import nuxt_plugin_portalAuth_b0078554 from 'nuxt_plugin_portalAuth_b0078554' // Source: ../../../plugins/portal/portalAuth.js (mode: 'client')
import nuxt_plugin_apiworkspace_2ef7b1e0 from 'nuxt_plugin_apiworkspace_2ef7b1e0' // Source: ../../../plugins/api/api-workspace.js (mode: 'client')
import nuxt_plugin_portalConstants_6fb5fd8e from 'nuxt_plugin_portalConstants_6fb5fd8e' // Source: ../../../plugins/site/portal/constant/portalConstants.js (mode: 'client')
import nuxt_plugin_portalUtils_75c5dbc1 from 'nuxt_plugin_portalUtils_75c5dbc1' // Source: ../../../plugins/site/portal/utils/portalUtils.js (mode: 'client')
import nuxt_plugin_portalPersistedStateclient_33c1f8d0 from 'nuxt_plugin_portalPersistedStateclient_33c1f8d0' // Source: ../../../plugins/site/portal/setting/portalPersistedState.client.js (mode: 'client')
import nuxt_plugin_axiosConfig_3653636f from 'nuxt_plugin_axiosConfig_3653636f' // Source: ../../../plugins/site/portal/setting/axiosConfig.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ko"},"title":"강원특별자치도교육청교육과학정보원","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"cache-control","content":"no-cache"},{"http-equiv":"expires","content":"0"},{"name":"viewport","content":"initial-scale=1.0,user-scalable=no,maximum-scale=1,width=device-width"},{"hid":"description","name":"description","content":""},{"hid":"og:title","property":"og:title","content":"강원특별자치도교육청교육과학정보원"},{"hid":"og:image","property":"og:image","content":"\u002Fimage_og.png"},{"hid":"og:description","property":"og:description","content":""},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fgwedu.go.kr"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"}],"script":[{"src":"\u002FcommonJS\u002FieCheck.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_storage_7387f8c1 === 'function') {
    await nuxt_plugin_storage_7387f8c1(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_fa7b7308 === 'function') {
    await nuxt_plugin_gtm_fa7b7308(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libmoduleplugin7915e51a_03e8c30a === 'function') {
    await nuxt_plugin_libmoduleplugin7915e51a_03e8c30a(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin22357a2f_25ce8c54 === 'function') {
    await nuxt_plugin_templatesplugin22357a2f_25ce8c54(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3c602e26 === 'function') {
    await nuxt_plugin_axios_3c602e26(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_5e512832 === 'function') {
    await nuxt_plugin_moment_5e512832(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefroala_7b108d3d === 'function') {
    await nuxt_plugin_vuefroala_7b108d3d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoPlayer_07925bfb === 'function') {
    await nuxt_plugin_videoPlayer_07925bfb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_animatedscrollto_34d657c6 === 'function') {
    await nuxt_plugin_animatedscrollto_34d657c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2animate_b95efc92 === 'function') {
    await nuxt_plugin_vue2animate_b95efc92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_548c0e4e === 'function') {
    await nuxt_plugin_vueawesomeswiper_548c0e4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuebar_2f78316c === 'function') {
    await nuxt_plugin_vuebar_2f78316c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fullcalendar_50d0b408 === 'function') {
    await nuxt_plugin_fullcalendar_50d0b408(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_utils_0acf3c7e === 'function') {
    await nuxt_plugin_utils_0acf3c7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_validate_20fc9549 === 'function') {
    await nuxt_plugin_validate_20fc9549(app.context, inject)
  }

  if (typeof nuxt_plugin_disableLogs_3cc606b9 === 'function') {
    await nuxt_plugin_disableLogs_3cc606b9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalCommon_2614ff1a === 'function') {
    await nuxt_plugin_portalCommon_2614ff1a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalAuth_b0078554 === 'function') {
    await nuxt_plugin_portalAuth_b0078554(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apiworkspace_2ef7b1e0 === 'function') {
    await nuxt_plugin_apiworkspace_2ef7b1e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalConstants_6fb5fd8e === 'function') {
    await nuxt_plugin_portalConstants_6fb5fd8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalUtils_75c5dbc1 === 'function') {
    await nuxt_plugin_portalUtils_75c5dbc1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalPersistedStateclient_33c1f8d0 === 'function') {
    await nuxt_plugin_portalPersistedStateclient_33c1f8d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axiosConfig_3653636f === 'function') {
    await nuxt_plugin_axiosConfig_3653636f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
